import axios from "axios";

const baseUrl = `${process.env.REACT_APP_GITO_API_URL}/External-Users/ExternalUser`;
//const baseUrl = "https://localhost:7241/ExternalUser";

// Function to get all users
export async function getAllExternalUsers(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/get-active-external-users`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch users');
    }
}

export async function getExternalUserByPublicId(publicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/get-external-user/${publicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to fetch user");
    }
}

export async function getLoggedInExternalUser(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/get-logged-in-external-user`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to fetch logged in external user");
    }
}

export async function acceptTerms(apiAccessToken) {
    try {
        const response = await axios.put(`${baseUrl}/accept-terms`, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to accept terms");
    }
}

export async function createExternalUser(userData, apiAccessToken) {
    try {
        const response = await axios.post(`${baseUrl}/invite-external-user`, userData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to create user");
    }
}

export async function updateExternalUser(publicId, userData, apiAccessToken) {
    try {
        const response = await axios.put(`${baseUrl}/update-external-user/`, userData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to update user");
    }
}

export async function deleteExternalUser(publicId, apiAccessToken) {
    try {
        await axios.delete(`${baseUrl}/delete-external-user/${publicId}`, {
            headers: {
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to delete user");
    }
}
